import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormService } from '../service/form.service';
import { environment } from '../../environments/environment';
import { renderError, setuserId, removeuserId,setPostcode,removePostcode } from '../helpers/utils';
import { reporting } from '../helpers/reporting';
import { NgForm } from '@angular/forms';
import { HomeComponent } from '../home/home.component';
import { DomSanitizer } from '@angular/platform-browser';
import { getPostcode, getuserId } from '../helpers/utils';
import { Frequency, Count } from '../helpers/data';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrl: './payment.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentComponent implements OnInit {
  futureBillsProperty!: string;
  installmentFrequencyProperty!: string;
  installmentCountID!: number;
  installmentCountProperty!: number;
  installmentAmountProperty !:string;
  commencementDateString: string | null = null;
  declarationAccepted!: boolean;
  formId!: string;
  postCode!: number;
  error_message!: string;
  error: any =  {};
  showError: boolean =false;
  apiFailure: boolean =false;
  ngForm: any;
  minDate: Date;
  maxDate: Date;
  selectedDate: Date | null = null; 

  submitted = false;

  safeURL: any;
  applicationData: any;
  scriptElement!: HTMLScriptElement;
  showAddToCalBtn: boolean = true;

  routeSub: Subscription | undefined;

  availableFrequency: Frequency[] = [
    { name: 'Weekly' },
    { name: 'Fortnightly' },
    { name: 'Monthly' }
  ];
  allCounts: Count[] = [
    { id: 101, frequencyName: 'Weekly', count: 2 },
    { id: 102, frequencyName: 'Weekly', count: 4 },
    { id: 103, frequencyName: 'Weekly', count: 8 },
    { id: 104, frequencyName: 'Fortnightly', count: 2 },   
    { id: 105, frequencyName: 'Fortnightly', count: 4 },
    { id: 106, frequencyName: 'Fortnightly', count: 6 },     
    { id: 107, frequencyName: 'Monthly', count: 2 },
    { id: 108, frequencyName: 'Monthly', count: 3 },        
  ];
  filteredCounts: Count[] = [];  

  @ViewChild('paymentForm') public paymentForm!: NgForm;

  constructor(private homeComp: HomeComponent, 
              private route: ActivatedRoute, 
              private http:HttpClient, 
              private formService:FormService, 
              private router: Router, 
              private _sanitizer: DomSanitizer, 
              private datePipe: DatePipe) {

    this.routeSub = this.route.params.subscribe(params => {
      this.formId = params['formId'];
      this.postCode = params['postCode'];
    });

    //this.formId = getuserId();
    //this.postCode = getPostcode();    
    console.log("payment postCode:"+this.postCode);


    const today = new Date();
          
    // Set the minimum date to two days from now
    this.minDate = new Date();
    this.minDate.setDate(today.getDate() + 2);

    // Set the maximum date to one month from now
    this.maxDate = new Date();
    this.maxDate.setMonth(today.getMonth() + 1);

    this.futureBillsProperty = "Make a selection";
    this.installmentFrequencyProperty = "Make a selection";

    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(environment.VIDEO_LINK);
    this.formService.getAppData.subscribe(data => {
      console.log("getAppdata");
      console.log(data);
      this.applicationData = data;
      this.processDataToForm();
    });
    this.scriptElement = document.createElement("script");
    this.scriptElement.src = "https://addevent.com/libs/atc/1.6.1/atc.min.js";
    document.body.appendChild(this.scriptElement);
  }
  ngAfterViewChecked(): void {
    setTimeout(() => {
      let element = document.getElementsByClassName('addeventatc_icon') as HTMLCollectionOf<HTMLElement>;
      element[0]?.remove();
      this.showAddToCalBtn = false;
    },1000);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      let element = document.getElementsByClassName('addeventatc_icon') as HTMLCollectionOf<HTMLElement>;
      element[0]?.remove();
      this.showAddToCalBtn = false;
    },1000);
  }  
  ngOnInit(): void {
    this.showError = false;
    this.apiFailure = false;    
    this.homeComp.showErrorMsg = false;
    this.homeComp.triggerChangeDetection();

    //this.formId = getuserId();
    //this.postCode = getPostcode();    
    reporting();
    this.showError = false;



  }

  processDataToForm(){
    if(this.applicationData.srw_pa_future_bills){
      this.futureBillsProperty = this.applicationData.srw_pa_future_bills;
    }
    if(this.applicationData.srw_pa_instalment_frequency){
      this.installmentFrequencyProperty = this.applicationData.srw_pa_instalment_frequency;
    }    
    if(this.applicationData.srw_pa_instalment_count){
      this.installmentCountProperty = this.applicationData.srw_pa_instalment_count;
      this.installmentCountID = this.findIdByFrequencyAndCount(this.installmentFrequencyProperty, this.installmentCountProperty);
      console.log("should be populated...");
      this.filteredCounts = this.allCounts.filter(count => count.frequencyName === this.installmentFrequencyProperty);
    }   
     if(this.applicationData.srw_pa_instalment_amount){
      this.installmentAmountProperty = this.applicationData.srw_pa_instalment_amount;
    }     

  }

  findIdByFrequencyAndCount(nameToMatch: string, countToMatch: number): number {
    for(var i=0; i<this.allCounts.length; i++){
      if(this.parseNumber(this.allCounts[i].count) == this.parseNumber(countToMatch) && this.allCounts[i].frequencyName == nameToMatch){
        return this.allCounts[i].id;
      }
    }
    return -1;
  }

  onChangeFrequency(frequencyName: string): void {
    this.filteredCounts = this.allCounts.filter(count => count.frequencyName === frequencyName);
  }  

  parseNumber(value: string | number): number {
  if (typeof value === 'number') {
    return value;
  }
  const parsed = Number(value.replace(/,/g, ''));

  // Check if the result is a valid number
  if (!isNaN(parsed) && isFinite(parsed)) {
    return parsed;
  }
  
  // Handle invalid input as needed (e.g., return 0, throw an error, etc.)
  return NaN; 
}

  onChangeInstallment(id:number): void {
    let dollarString = this.applicationData.sr_pa_amount_due;
    let stripped = dollarString.slice(1);
    this.installmentCountProperty = this.findCountFromID(id);
    let new_installment = this.parseNumber(stripped) / this.parseNumber(this.installmentCountProperty);
    console.log(new_installment+"*"+this.installmentAmountProperty);
    const finalCurrencyString = `$${Math.floor(new_installment).toFixed(0)}`;
    this.installmentAmountProperty = finalCurrencyString;
  }

  findCountFromID(idToFind:number):number {
    for (var i=0; i<this.allCounts.length; i++)
    {
      console.log(this.allCounts[i].id+"<"+idToFind);
      if(this.parseNumber(this.allCounts[i].id) === this.parseNumber(idToFind)){
        return this.allCounts[i].count;
      }
    }
    return 1;
  }

  onDateChange(event: any): void {
    this.selectedDate = event.value;

    if (this.selectedDate) {
      this.commencementDateString = this.datePipe.transform(this.selectedDate, 'ddMMYYYY');
      console.log('Formatted Date:', this.commencementDateString);
    } else {
      this.commencementDateString = this.datePipe.transform(this.minDate, 'ddMMYYYY');
    }
  }


 updatePayArrangement(event: Event) {
  event.preventDefault();
  this.submitted = false;
  if (this.paymentForm.invalid) {
    return;
  } else {
    console.log("valid form");
    console.log(this.formId+","+this.postCode);

      let data  = {
        "client": environment.APP_CLIENTID,
        "srw_postcode": this.postCode,
        "srw_pa_future_bills":this.futureBillsProperty,
        "srw_pa_instalment_frequency":this.installmentFrequencyProperty,
        "srw_pa_instalment_count":this.installmentCountProperty,
        "srw_pa_instalment_amount":this.installmentAmountProperty,
        "srw_pa_commencement_date":this.commencementDateString
      }
      this.formService.checkSession(this.applicationData.formId || getuserId()).subscribe(sessionRes => {
        this.formService.saveFormData(this.applicationData.formId || getuserId(), data).subscribe(res => {
          this.formService.setAppData({...this.applicationData, ...data});
          this.router.navigate(['/success'])
        },error=>{
          this.apiFailure = true;
          this.error_message = environment.APP_MESSAGE_API_FAILURE;
          console.log('error', error);
        })
      },error=>{
        this.apiFailure = true;
        this.error_message = environment.APP_MESSAGE_API_FAILURE;
        console.log('error', error);
      })
  }
 }
}
